<template>
    <v-dialog v-model="dialogAffect" max-width="300px" persistent>
        <v-card elevation="5">
            <v-card-title class="text-subtitle-1">
                Mobilidade
            </v-card-title>
            <v-divider />            
            <v-card-text>
                <p class="ma-2 text-sm-body-2">
                    A deficiência <b>{{ disabilitySelected.DescricaoDefiencia }}</b> afeta a mobilidade?
                </p>
             </v-card-text>  
            <v-divider />
            <v-card-actions>
                <v-spacer/>
                <v-btn 
                    color="primary"
                    outlined
                    rounded
                    elevation="0"
                    left
                    @click="setAffect(true)"
                ><v-icon small left>mdi-wheelchair-accessibility</v-icon>Sim</v-btn>
                <v-btn 
                    color="primary"
                    outlined
                    rounded
                    elevation="0"
                    left
                    @click="setAffect(false)"
                ><v-icon small left>mdi-human</v-icon>Não</v-btn>
            </v-card-actions>                                   
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data(){
        return {
            disabilitySelected: '',
            dialogAffect: false,
            listDisabilities: [],
        }        
    },
    mounted() { },
    methods: {
        setAffect(value){
            if(this.disabilitySelected != null && this.disabilitySelected.AfetaMobilidade != undefined){
                // console.log('Pg ConfirmMobilityAffected - Lista de deficiências antes da alteração');
                // console.log(JSON.parse(JSON.stringify(this.listDisabilities)));

                this.disabilitySelected.AfetaMobilidade = value;

                let idDisability = this.listDisabilities.map(e=>e.DeficienciaId==this.disabilitySelected.DeficienciaId);

                if(idDisability.length == 1 && idDisability[0] != false)
                    this.listDisabilities.splice(idDisability,1);
                    
                this.listDisabilities.push(this.disabilitySelected);              
            } 

            this.showModalAffect(false);
        },
        loadDisabilityRequest(item, list){
            //recebe o item vindo da tela origem e atribui seu valor à variavel
            this.disabilitySelected = item;
            this.listDisabilities = list;
        },
        showModalAffect(value){
            this.dialogAffect = value;
        }        
    }
}
</script>

